export default __webpack_public_path__ + "static/media/icon_PinkMetal.8169e526.png";